import React from 'react';
import type { StudentNoteItem } from '../../../types/orchestrator';
import { formatDate } from '../../../utils';
import ContentCard from '../ContentCard/ContentCard';
import CopyTextIconButton from '../CopyTextIconButton/CopyTextIconButton';
import Icon from '../Icon/Icon';
import styles from './StudentNotesHistorySection.module.css';

interface StudentNoteHistoryItemProps {
  note: StudentNoteItem;
  canDelete?: boolean;
  deleting?: boolean;
  onDelete?: () => void;
}

const StudentNoteHistoryItem: React.FC<StudentNoteHistoryItemProps> = ({
  note,
  canDelete = false,
  deleting = false,
  onDelete,
}) => {
  const authorName = note.author_name?.trim() || 'Usuário desconhecido';
  const createdDate = formatDate(note.created_at);

  return (
    <ContentCard className={styles.item}>
      <div className={styles.itemHeader}>
        <div className={styles.noteMetadata}>
          <div className={styles.noteMetaField}>
            <span>Data</span>
            <strong>{createdDate}</strong>
          </div>
          <div className={styles.noteMetaField}>
            <span>Responsável</span>
            <strong>{authorName}</strong>
          </div>
        </div>
        {canDelete && onDelete ? (
          <button
            type="button"
            className={styles.deleteButton}
            aria-label="Excluir observação"
            title="Excluir observação"
            onClick={onDelete}
            disabled={deleting}
          >
            <Icon name="delete" size={16} color="var(--color-solid-danger)" />
          </button>
        ) : null}
      </div>
      <div className={styles.noteCopySection}>
        <div className={styles.noteCopyLabel}>
          <span>Observação</span>
        </div>
        <div className={styles.noteCopyValue}>
          <span className={styles.text}>{note.note}</span>
          <CopyTextIconButton value={note.note} ariaLabel="Copiar observação" />
        </div>
      </div>
    </ContentCard>
  );
};

export default StudentNoteHistoryItem;
